module.exports = __webpack_public_path__ + "static/media/remodel2.90932f23.png";